import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Label,
  LabelList,
  Text,
  ResponsiveContainer,
} from "recharts";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import _keyBy from "lodash/keyBy";

const BAR_CHART_WIDTH = 550;

/*
  This is the default font size for MUI icons.
  It is currently used to position the check correctly.
  It cannot currently be used to resize the check. Do not change this value!
*/
const CHECK_SIZE = 24;

const CORRECT_COLOR = "#489617";
const INCORRECT_COLOR = "#c2c2d1";
const TEXT_COLOR = "#272736";

export default function PollResults({ question, results = {} }) {
  const resultsByChoiceId = _keyBy(results, "choiceId");

  const renderCustomizedLabel = (props) => {
    const choiceId = props.value;
    const { choiceText, correct } = resultsByChoiceId[choiceId];

    return (
      <Text
        fill={TEXT_COLOR}
        fontWeight={correct ? "bold" : null}
        width={BAR_CHART_WIDTH}
        x={props.x + props.offset}
        y={props.y - props.offset}
      >
        {`${choiceId}) ${choiceText}`}
      </Text>
    );
  };

  const renderCorrectCheck = (props) => {
    const { x, y, viewBox } = props;

    return (
      props.value && (
        <CheckIcon
          htmlColor={CORRECT_COLOR}
          x={x + viewBox.width}
          y={y + viewBox.height / 2 - CHECK_SIZE / 2}
          inheritViewBox
        />
      )
    );
  };

  return (
    <div id="poll-graph-container">
      {Object.keys(results).length ? (
        <Box
          width={BAR_CHART_WIDTH}
          height="90%"
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
        >
          <strong
            style={{
              paddingLeft: "10%",
              fontSize: "20px",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            {question}
          </strong>
          {/* adapt to the size of parent container (Box)  */}
          <ResponsiveContainer>
            <BarChart
              layout="vertical"
              data={results}
              margin={{ bottom: 25, right: 25 }}
            >
              <XAxis type="number" allowDecimals={false}>
                <Label value="Votes" position="bottom" />
              </XAxis>
              <YAxis
                dataKey="choiceId"
                tick={false}
                label={{ value: "Choices", angle: -90 }}
                domain={[0.5, results.length + 0.25]} //extend max domain so that last bar is not overlapping the x-axis
              />
              <Bar dataKey="votes" barSize={50}>
                {results.map((entry) => (
                  <Cell
                    key={`cell-${entry.choiceId}`}
                    fill={entry.correct ? CORRECT_COLOR : INCORRECT_COLOR}
                  />
                ))}
                <LabelList dataKey="choiceId" content={renderCustomizedLabel} />
                <LabelList dataKey="correct" content={renderCorrectCheck} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      ) : (
        <h2>No poll response data to display</h2>
      )}
    </div>
  );
}
